import { DateTime } from 'luxon';

export function roundTimeToNearestTimeInterval(datetime: string, timeInterval: number): string | null {
    const start = DateTime.fromISO(datetime);
    const remainder = timeInterval - (start.minute % timeInterval);
    const roundedTime = start.set({ second: 0 }).plus({ minutes: remainder });
    return roundedTime.toISO();
}

export function getSoonestTimeByInterval(interval: number): string | null {
    return roundTimeToNearestTimeInterval(DateTime.local().set({ second: 0 }).toISO(), interval);
}
